import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { CustomCodeService } from '../custom-code.service';

import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-authentication-native',
  templateUrl: './authentication-native.component.html',
  styleUrls: ['./authentication-native.component.css']
})

export class AuthenticationNativeComponent implements OnInit {
  authDetailsForm: FormGroup;
  inputFields = 1;
  inputLoopArray = [1];
  selectedCustomCode = ''
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  isChecked: boolean = false;
  constructor(private router: Router, private _location: Location, private _matDialog: MatDialog, private activatedRoute: ActivatedRoute, private customCodeService: CustomCodeService, private _snackBar: MatSnackBar) { 
  }
  ngOnInit(): void {
    this.authDetailsForm = new FormGroup({
      authUrl: new FormControl('', Validators.required),
      inputFieldType1: new FormControl('', Validators.required),
      inputFieldValue1: new FormControl('', Validators.required),
      inputFieldName1: new FormControl('', Validators.required),
    })
    this.selectedCustomCode = this.activatedRoute.snapshot.params.customCode;
    this.getCustomCodeDetails();
  }
  
  buildAuthForm(data) {

     if (data.authentication) {
      let index = 1;
      for (let users_detail of data.authentication.user_details) {
        if (index == 1) {
          this.authDetailsForm.patchValue({
            inputFieldType1: users_detail.type,
            inputFieldValue1: users_detail.value,
            inputFieldName1: users_detail.name
          })
        } else {
          this.inputLoopArray.push(index);
          this.inputFields = index;
          const formType = `inputFieldType${index}`;
          const formValue = `inputFieldValue${index}`;
          const formName = `inputFieldName${index}`;
          const newInputFiledtypeFormControl = new FormControl(users_detail.type, Validators.required);
          const newInputFiledvalueFormControl = new FormControl(users_detail.value, Validators.required);
          const newInputFilednameFormControl = new FormControl(users_detail.name, Validators.required);

          this.authDetailsForm.addControl(formType, newInputFiledtypeFormControl);
          this.authDetailsForm.addControl(formValue, newInputFiledvalueFormControl);
          this.authDetailsForm.addControl(formName, newInputFilednameFormControl);
        }
        index++;

      }
      this.authDetailsForm.patchValue({
        authUrl: data.authentication.webhook_url,
      })
      this.isChecked = true;
    } else {
      this.isChecked = false;
    }
  }
  getCustomCodeDetails() {
    this.customCodeService.getCustomCodeDetails(this.selectedCustomCode).subscribe(
      (res) => {
        this.buildAuthForm(res);
      }
    )
  }
  addNextInputField() {
    if (this.inputFields == 4) return;
    this.inputFields++;
    this.inputLoopArray.push(this.inputFields)
    const formType = `inputFieldType${this.inputFields}`;
    const formValue = `inputFieldValue${this.inputFields}`;
    const formName = `inputFieldName${this.inputFields}`;
    const newInputFiledtypeFormControl = new FormControl('', Validators.required);
    const newInputFiledvalueFormControl = new FormControl('', Validators.required);
    const newInputFilednameFormControl = new FormControl('', Validators.required);

    this.authDetailsForm.addControl(formType, newInputFiledtypeFormControl);
    this.authDetailsForm.addControl(formValue, newInputFiledvalueFormControl);
    this.authDetailsForm.addControl(formName, newInputFilednameFormControl);
  }

  deleteInputField(filedNumber) {
    // if (this.inputFields == 1 || filedNumber == 1) return;
    const formType = `inputFieldType${filedNumber}`;
    const formValue = `inputFieldValue${filedNumber}`;
    const formName = `inputFieldName${filedNumber}`;
    this.authDetailsForm.removeControl(formType);
    this.authDetailsForm.removeControl(formValue);
    this.authDetailsForm.removeControl(formName);
    this.inputFields--;

    this.inputLoopArray = this.inputLoopArray.filter(item => item !== filedNumber);

  }

  toggle() {
    if(!this.isChecked){
      this.isChecked = !this.isChecked;
    }
    else{
      this.deactivateAuthentication();
    }
  }
  backClicked() {
    if(this.isChecked){
      this.router.navigate([`/custom-code/edit/${this.selectedCustomCode}`]);
    }
    else{
      this.router.navigate([`/custom-code/authentication/${this.selectedCustomCode}`]);
    }
  }

  deactivateAuthentication() {
    const dialogRef = this._matDialog.open(deactivateAuthenticationDialog, {
      data: {
        customCode: this.selectedCustomCode, 
      }
    });
    dialogRef.afterClosed().subscribe((result) =>{
      if (result === 'confirm'){

      this.authDetailsForm.reset(); 
      let reqBody = {
        authentication: null
      }
      this.customCodeService.updateAuthentication(this.selectedCustomCode,reqBody).subscribe(
        (response) =>{
        },
        (error) =>{
          if(error.status == 200){
            this.getCustomCodeDetails();
            this.inputFields = 1
            this.inputLoopArray = [1]
          }
        }
      )
      }
      else{
        this.isChecked = true;
      }
    })
  }
  updateAuthentication() {
    if (this.authDetailsForm.valid) {
      let data = this.authDetailsForm.value;
      let reqBody = {
        authentication: {
          method: "NATIVE",
          webhook_url: data.authUrl,
          user_details: []
        }
      }

      for (let i = 1; i <= 4; i++) {
        const formType = `inputFieldType${i}`;
        const formValue = `inputFieldValue${i}`;
        const formName = `inputFieldName${i}`;
        if (data[formName] && data[formName] != '' && data[formValue] && data[formValue] != '' && data[formType] && data[formType] != '') {
          const obj = {
            name: data[formName],
            value: data[formValue],
            type: data[formType],
          }
          reqBody.authentication.user_details.push(obj)
        }
      }
      this.customCodeService.updateAuthentication(this.selectedCustomCode, reqBody).subscribe(
      (res) => {}, 
      (error) => {
        if(error.status == 200){
          this.isChecked = true
          this._snackBar.open('Authentication updated succesfully', 'close', {
            duration: 3000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
          });
        }
        else {
          let message = error.error.message ? error.error.message : "Something Went Wrong";
          this._snackBar.open(message, 'close', {
            duration: 3000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
          });
        }
      }
      )
    }
    else{
      this._snackBar.open('Fill others field also', 'close', {
        duration: 3000,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
      });
    }
  }
}

@Component({
  selector: 'app-authentication-native',
  templateUrl: './deactivate-auth.html',
  styleUrls: ['./authentication-native.component.css']
})

export class deactivateAuthenticationDialog {

  customCode :any;
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(public dialogRef: MatDialogRef<deactivateAuthenticationDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private _dialog: MatDialog, private customCodeService: CustomCodeService,private _snackBar: MatSnackBar) {
    this.customCode = data.customCode
  }
  closePopUp(action: 'confirm' | 'cancel') {
    this.dialogRef.close(action);
  }
  authenticationDetail: any;
  deactivateAuth(){
    this.customCodeService.getCustomCodeDetails(this.customCode).subscribe(
      (res) =>{
        this.dialogRef.close({
          event: 'close',
          data: {
            authenticationDetail: res.authentication
          }
        });
      },
    )
  }

}